export default "__VITE_ASSET__BTb3rIVV__"